import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';
import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import styles from './JuniorsSection.module.css';
import { JuniorItem } from '@features/landing/shared/ui/components/JuniorItem/JuniorItem';

export function JuniorsSection() {
  return (
    <LandingSection>
      <div className={styles.root}>
        <LandingSectionTitle>
          <span className={styles.title}>
            В Гран-при РШШ сыграют
            <br />
            сильнейшие юниоры России
          </span>
          <span className={styles.titleMobile}>
            В Гран-при РШШ
            <br />
            сыграют сильнейшие
            <br />
            юниоры России
          </span>
        </LandingSectionTitle>

        <div className={styles.content}>
          <JuniorItem
            imgSrc="/images/landing/juniors/junior4.jpg"
            imgAlt="Анна Шухман, чемпионка мира в составе сборной России, чемпионка России среди женщин, чемпионка мира до 20, олимпийская чемпионка"
            title={
              <>
                <strong>Анна Шухман</strong>, чемпионка мира в составе сборной
                России, чемпионка России среди женщин, чемпионка мира до 20,
                олимпийская чемпионка
              </>
            }
            quote={
              <>
                — Я всегда с удовольствием участвую в онлайн турнирах <br />
                на chessopen.ru, когда есть возможность. Радует, что платформа
                постоянно совершенствуется и развивается!
              </>
            }
          />

          <JuniorItem
            imgSrc="/images/landing/juniors/junior2.jpg"
            imgAlt="Алиса Юнкер, многократная чемпионка мира"
            title={
              <>
                <strong>Алиса Юнкер</strong>, многократная чемпионка мира
              </>
            }
            quote={
              <>
                — Полюбила турниры на chessopen.ru. Много сильных соперников, с
                которыми я играла и в живых турнирах. Так играть куда
                интереснее, чем с никнеймами, когда не знаешь, с кем играешь.
              </>
            }
          />

          <JuniorItem
            imgSrc="/images/landing/juniors/junior1.jpg"
            imgAlt="Федор Антипов, чемпион России"
            title={
              <>
                <strong>Федор Антипов</strong>, чемпион России
              </>
            }
            quote={
              <>
                — Я рад снова принять участие в турнирах на платформе ChessOpen.
                Она хорошо работает, не лагает. Крутое оформление доски, часов и
                т.д. А ещё я люблю заходить на ChessOpen, чтобы посмотреть
                трансляции различных турниров, как топовых, так и детских.
              </>
            }
          />

          <JuniorItem
            imgSrc="/images/landing/juniors/junior3.jpg"
            imgAlt="Семен Новожилов, международный мастер"
            title={
              <>
                <strong>Семен Новожилов</strong>, международный мастер
              </>
            }
            quote={
              <>
                — Мне очень нравится играть на chessopen.ru, эта крутая
                платформа и я обязательно приму участие в серии Гран-при и по
                блицу и по рапиду!
              </>
            }
          />
        </div>
      </div>
    </LandingSection>
  );
}
